import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore, SupportLink } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class InternalErrorConfigService {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getSupportLink(): SupportLink {
		return this.config.get((config) => config.core.errors.internalError!.supportLink, {});
	}

	getHideRefresh(): boolean {
		return this.config.get((config) => config.core.errors.internalError?.hideRefresh, false);
	}
}
